import React, { useState } from 'react';

import styles from './styles';

import Modal from '../../../common/Modal';
import { Table, TableCell, TableHead, TableRow, TableBody, Typography, withStyles } from '@material-ui/core';
import StyledTableRow from './../../../common/StyledTableRow';
import ViewForm from './ViewForm';

import Moment from 'moment';
import PropTypes from 'prop-types';
import { ORGANISATION_FORM_TYPES } from '../../../../collums-constants';
import { clone } from 'lodash';

const FormHistory = ({ classes, form, customer, onCancel }) => {
    const [viewingForm, setViewingForm] = useState();

    // Newest first
    const sortedLogs = [...(form.logs || [])].sort(
        (a, b) => new Date(b.date || form.createdAt) - new Date(a.date || form.createdAt)
    );

    const showFormAtStage = logData => {
        if (form.model.type === ORGANISATION_FORM_TYPES.CONSENT) {
            const consentCopy = clone(form);
            // Show the consent PDF as it was at this log (per-version), not just the latest one.
            if (logData.signed) {
                consentCopy.pdfUrl = logData.pdfUrl || form.pdfUrl;
            } else {
                delete consentCopy.pdfUrl;
            }
            setViewingForm({ ...consentCopy, signedDate: logData.date });
        } else {
            const data = logData.newData || {};
            const modelCopy = clone(form.model);
            (modelCopy.fields || []).forEach(field => {
                if (data[field.id]) Object.assign(field, data[field.id]);
            });
            setViewingForm({
                ...form,
                model: modelCopy,
                signedDate: logData.date
            });
        }
    };

    return (
        <>
            <Modal id="form-log" isOpen title="" size="md" onCancel={onCancel} hideTitle hideCancelButton>
                <div className={classes.header}>
                    <Typography variant="span" className={classes.title}>
                        Form History Log
                    </Typography>
                </div>
                <div>
                    {(form.logs || []).length > 0 ? (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableHeader}>{'Time & Date'}</TableCell>
                                    <TableCell className={classes.tableHeader}>Action</TableCell>
                                    <TableCell className={classes.tableHeader}>Changed by</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {sortedLogs.map((log, index) => (
                                    <StyledTableRow key={index}>
                                        <TableCell className={classes.defaultFont}>
                                            {Moment(log.date || form.createdAt).format('DD/MM/YYYY HH:mm')}
                                        </TableCell>
                                        <TableCell className={classes.defaultFont}>
                                            <span
                                                onClick={() => {
                                                    showFormAtStage(log);
                                                }}
                                                className={classes.link}
                                            >
                                                {log.action}
                                            </span>
                                        </TableCell>
                                        <TableCell className={classes.defaultFont}>
                                            {log.changedBy || 'Online'}
                                        </TableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    ) : (
                        <Typography className={classes.defaultFont} variant="h5" align="center">
                            Form log unavailable or nonexistent.
                        </Typography>
                    )}
                </div>
            </Modal>
            {viewingForm && (
                <ViewForm
                    selectedItem={viewingForm}
                    type={viewingForm.model.type}
                    customer={customer}
                    onCancel={() => setViewingForm()}
                />
            )}
        </>
    );
};

FormHistory.propTypes = {
    classes: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    customer: PropTypes.object,
    onCancel: PropTypes.func.isRequired
};

export default withStyles(styles)(FormHistory);
